import React, { useEffect, useState } from 'react';
import { FileCode2 } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import MergeFieldInput from './MergeFieldInput';

const SourceCodeModal = ({ isOpen, onClose, html, onSave, token }) => {
  const [draft, setDraft] = useState(html || '');

  useEffect(() => {
    if (isOpen) {
      setDraft(html || '');
    }
  }, [isOpen, html]);

  const handleSave = () => {
    onSave?.(draft);
    onClose?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent priority className="max-w-2xl p-0 gap-0" data-testid="source-code-modal">
        <div className="p-6 pb-4">
          <DialogHeader className="space-y-2 text-left mb-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center">
                <FileCode2 size={18} className="text-blue-600" />
              </div>
              <DialogTitle className="text-lg font-semibold text-slate-900">
                Source code
              </DialogTitle>
            </div>
            <DialogDescription className="sr-only">
              Edit the HTML source for this email.
            </DialogDescription>
          </DialogHeader>
          <MergeFieldInput
            multiline
            value={draft}
            onValueChange={setDraft}
            token={token}
            data-testid="source-code-textarea"
            inputClassName="min-h-[280px] font-mono text-sm border-blue-200 focus-visible:ring-blue-500"
            spellCheck={false}
          />
        </div>
        <div className="border-t border-slate-200 px-6 py-4 flex items-center justify-end gap-3">
          <Button variant="outline" onClick={onClose} data-testid="source-code-cancel">
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            className="bg-blue-600 hover:bg-blue-700 text-white"
            data-testid="source-code-save"
          >
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SourceCodeModal;
